/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

export {litSsrPlugin, LitSsrPluginOptions} from './lib/lit-ssr-plugin.js';
